// extracted by mini-css-extract-plugin
export default {"title":"title-OJ4yM","item":"item-xWt7c","footer":"footer-D9iqs"};